<template>
  <section id="chapterBoards">
    <div class="container">
      <h2>Chapter Boards</h2>
      <div v-for="board in boards">
        <h4 v-html="board.board_name"></h4>
        <div class="board">
          <div v-for="boardMember in board.board_members">
            <h5 v-html="boardMember.name"></h5>
            <p v-html="boardMember.organization"></p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'chapter-boards',
  props: ['boards']
}
</script>

<style lang="scss" scoped>
@import '~assets/styles/vars';

section {
  padding: 7rem 0 6rem;
  background-color: white;
  text-align: center;
}

h2 {
  color: $brand-primary;
  margin-bottom: 3rem;
}

h4 {
  font-size: 1.25rem;
  text-transform: uppercase;
  font-weight: bold;
  margin: 2rem 0;
  color: $brand-primary;
}

.board {
  @include media('tablet') {
    display: flex;
    flex-wrap: wrap;
    > div {
      width: 30%;
    }
  }
  > div {
    margin-bottom: 1rem;
    @include media('tablet') {
      margin-right: 5%;
      &:nth-child(3n) {
        margin-right: 0;
      }
    }
  }
  h5 {
    font-size: 1rem;
    text-transform: uppercase;
    font-weight: bold;
  }
}
</style>



// WEBPACK FOOTER //
// ChapterBoards.vue?46c30d7c